import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { subscriptionsEndpoint } from './subscription.config';
import { SubscriptionObject } from './subscription.types';

type SubscriptionState = {
  subscriptionList?: SubscriptionObject[];
};

const initialState: SubscriptionState = {};

const subscriptionReducer = createReducer(initialState, (builder) => {
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    switch (payload.resourceId) {
      case subscriptionsEndpoint:
        state.subscriptionList = payload.response.data.responseObject;
        return;
    }
  });
});

export default subscriptionReducer;
